import Dexie, { Table } from "dexie";
import { DrawerType, DrawerDetailsProps } from '../DataEstate/SideDrawers/constants';
export type NodeType = "module" | "submodule" | "page";

export interface NavNode {
  id: string;              // e.g. platformobservability:tableau:performance
  type: NodeType;
  key: string;
  parentId?: string;
  title: string;
  route?: string;
  moduleRootId: string;    // top-level module key
  order?: number;
  breadcrumb: string;      // "Platform Observability / Tableau / Performance"
  path: string[];          // ["platformObservability","tableau","performance"]
  tags?: string[];
  terms: string[];
}

export interface NavItem {
  id: string;              // e.g. platformobservability:tableau:performance:job
  pageId: string;         
  key: string;             // anchor key ("job")
  label: string;           // "Jobs"
  tags?: string[];
  route: string;           // inherited from page
  url: string;             // route#anchor
  moduleRootId: string;
  breadcrumb: string;      // "... / Performance / Jobs"
  terms: string[];         // tokenized multiEntry index
  drawerType?: DrawerType;
  drawerProps?: DrawerDetailsProps;
}

class NavDB extends Dexie {
  navNodes!: Table<NavNode, string>;
  navItems!: Table<NavItem, string>;

  constructor() {
    super("navDB");
    this.version(1).stores({
      navNodes: "id, type, parentId, moduleRootId, route, *terms",
      navItems: "id, pageId, moduleRootId, route, *terms",
    });
  }
}

export const navDB = new NavDB();
